export default __webpack_public_path__ + "assets/391e3d9263841556b07a1b05b3a31f7d.svg";